export default __webpack_public_path__ + "static/Plots0028-bca33d20a5a0df1dd7dda37b2d9ce929.jpg";